import { render, staticRenderFns } from "./DataLog.vue?vue&type=template&id=47b13bfc&scoped=true&"
import script from "./DataLog.vue?vue&type=script&lang=js&"
export * from "./DataLog.vue?vue&type=script&lang=js&"
import style0 from "./DataLog.vue?vue&type=style&index=0&id=47b13bfc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b13bfc",
  null
  
)

export default component.exports